/* global BTRenderer, $ */
var bt, BetByObject;
var betSlipOffsetBottom = calculateBetSlipOffsetBottom(); // Initial calculation
var betSlipOffsetTop = calculateBetSlipOffsetTop();

export function callBetByGame(brandId, UserThemeName, jwtToken, lang="en") {
    bt =new BTRenderer().initialize({
            brand_id: brandId,
            token: jwtToken,
            themeName: UserThemeName,
            lang: lang,
            target: document.getElementById('betby'),
            betSlipOffsetTop: betSlipOffsetTop,
            betSlipOffsetBottom: betSlipOffsetBottom,
            betSlipOffsetRight: 0,
            stickyTop: betSlipOffsetTop,
            betslipZIndex: 999,
            onLogin: function () { BetByObject.invokeMethodAsync("OnLoginBetByGame"); },
            onRegister: function () { BetByObject.invokeMethodAsync("OnRegisterBetByGame"); },
            onRecharge: function () { BetByObject.invokeMethodAsync("OnRechargeBetByGame"); },
            onSessionRefresh: function () { BetByObject.invokeMethodAsync("LaunchBetByGame"); },
            onTokenExpired: function () { return BetByObject.invokeMethodAsync("OnTokenExpired"); },
        })
}

export function BetBySetObject(BetBySetObject) {
    BetByObject = BetBySetObject;
}

function AddLoaderClass(controlId, className) {
    var control = document.getElementById(controlId);
    $("#" + control).addClass(className);
}

function RemoveLoaderClass(controlId, className) {
    $(".nk-preloader").fadeOut();
}

export function killBetBy() {
    if (!bt) return;
    bt.kill();
}

function calculateBetSlipOffsetBottom() {
    // You can define your logic here to calculate betSlipOffsetBottom based on screen size.
    // For example, you can use window.innerHeight or other criteria.
    // Keep betslip attached to the bottom nav without extra gap on mobile.
    if (window.innerWidth <= 767) {
        return 70;
    }
    if (window.innerWidth <= 1054 && window.innerWidth >= 768) {
        return 70; // Set a smaller value for smaller screens
    } else {
        return 55; // Default value for larger screens
    }
}
function calculateBetSlipOffsetTop() {
    // You can define your logic here to calculate betSlipOffsetTop based on screen size.
    // For example, you can use window.innerHeight or other criteria.

    if (window.innerWidth < 1199 && window.innerWidth >= 992) {     
        return 70; // Set a smaller value for smaller screens
    }
    else if (window.innerWidth <= 991 && window.innerWidth >= 768) {
        return 58;
    }
    else if (window.innerWidth <= 767 && window.innerWidth >= 320) {
        return 75;
    }
    else {
        return 96; // Default value for larger screens
    }
}

// Update betSlipOffsetBottom when the window is resized
window.addEventListener("resize", function () {
    betSlipOffsetBottom = calculateBetSlipOffsetBottom();
    betSlipOffsetTop = calculateBetSlipOffsetTop();
    // Update the initialized BetBy instance if it exists
    if (bt) {
        bt.updateOptions({
            betSlipOffsetBottom: betSlipOffsetBottom,
            betSlipOffsetTop: betSlipOffsetTop,
            stickyTop: betSlipOffsetTop,
        });
    }
});
